<template>
  <div id="projects" class="container section scrollspy section-padding">
    
    <div class="header-projects center-align">
      <h3 class="title-main">Proyectos Destacados</h3>
      <div class="divider-custom"></div>
      <p class="subtitle-nda">
        <i class="material-icons tiny">lock</i> 
        Portafolio de soluciones públicas. Debido a políticas de <strong>propiedad intelectual</strong>, los sistemas internos desarrollados para organizaciones privadas se mantienen bajo <strong>reserva profesional</strong>.
      </p>
    </div>

    <div class="row flex-container-projects">
      <div
        class="card hoverable project-card"
        v-for="(proyecto, index) in proyectos"
        :key="index"
      >
        <div class="card-image waves-effect waves-block waves-light project-image-container">
          <div class="overlay-gradient"></div>
          <img 
            class="activator project-img responsive-img" 
            :src="proyecto.url_image" 
            :alt="proyecto.nombreProyecto" 
          />
          <span class="btn-floating halfway-fab waves-effect waves-light green activator shadow-pulse">
            <i class="material-icons">add</i>
          </span>
        </div>

        <div class="card-content">
          <span class="card-title activator grey-text text-darken-4 text-bold">
            {{ proyecto.nombreProyecto }}
            <i class="material-icons right">more_vert</i>
          </span>
          <div class="card-links">
            <a :href="proyecto.url_sitioWeb" target="_blank" class="btn-flat waves-effect btn-web-link">
              <i class="material-icons left">language</i> Sitio Web
            </a>
          </div>
        </div>

        <div class="card-reveal">
          <span class="card-title grey-text text-darken-4 text-bold">
            {{ proyecto.nombreProyecto }}
            <i class="material-icons right">close</i>
          </span>
          <p class="project-description">
            {{ proyecto.descripcion }}
          </p>
          <div class="card-action center-align">
            <a :href="proyecto.url_sitioWeb" target="_blank" class="btn green darken-1 waves-effect waves-light round-btn">
              <i class="material-icons left">launch</i> Explorar Proyecto
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeccionProyectos',
  data() {
    return {
      proyectos: [
        {
          nombreProyecto: "Galápagos Previene",
          url_image: "/./img/recursos/imagenes_proyectos/galapagospreviene.webp",
          descripcion:
            "🌋 Sistema Insular de Gestión de Riesgos. Plataforma estratégica diseñada para la prevención y monitoreo de amenazas naturales en el archipiélago, optimizando la respuesta ciudadana.",
          url_sitioWeb: "https://galapagospreviene.asoprofesionalesriesgo.org/",
        },
        {
          nombreProyecto: "Portoviejo Previene",
          url_image: "/./img/recursos/imagenes_proyectos/app1.webp",
          descripcion:
            "Gestión de alertas tempranas y recomendaciones de seguridad ciudadana. Este sistema permite la comunicación directa entre la Jefatura de Riesgos y la comunidad ante eventos naturales.",
          url_sitioWeb: "https://griesgos.portoviejo.gob.ec/",
        },
      ],
    };
  },
};
</script>

<style scoped>
/* Estructura General */
.section-padding { padding: 5rem 0; }

.title-main {
  color: #5b5b5b; /* Color Secundario */
  font-weight: 800;
  font-size: 3rem;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: -1px;
}

.divider-custom {
  height: 5px;
  width: 80px;
  background-color: #FED131; /* Color Principal Amarillo */
  margin: 0 auto 20px;
  border-radius: 10px;
}

.subtitle-nda {
  color: #757575;
  font-size: 1.1rem;
  max-width: 800px;
  margin: 0 auto 40px;
  line-height: 1.6;
  text-align: center;
}

/* Flexbox Responsivo */
.flex-container-projects {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}

/* Tarjetas Estilizadas */
.project-card {
  border-radius: 15px !important;
  overflow: hidden;
  width: 320px !important;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) !important;
  border: 1px solid rgba(0,0,0,0.05);
  box-shadow: 0 4px 15px rgba(0,0,0,0.08) !important;
}

.project-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 35px rgba(0,0,0,0.15) !important;
}

/* Imagen 100% Responsiva */
.project-image-container {
  height: 200px; /* Altura fija para mantener uniformidad */
  overflow: hidden;
  background-color: #f5f5f5;
}

.project-img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover; /* Ajusta la imagen sin deformarla */
  object-position: center;
  transition: transform 0.6s ease;
}

.project-card:hover .project-img {
  transform: scale(1.1);
}

/* Textos y Botones */
.text-bold { font-weight: 700 !important; font-size: 1.25rem !important; }

.project-description {
  font-size: 1rem;
  color: #444;
  line-height: 1.6;
  margin-top: 20px;
  text-align: justify;
}

.btn-web-link {
  color: #008744 !important; /* Green */
  font-weight: 700;
  text-transform: none;
  padding: 0;
}

.round-btn { 
  border-radius: 25px; 
  text-transform: none; 
  font-weight: 600; 
  padding: 0 30px;
}

/* Ajustes para Dispositivos Móviles */
@media only screen and (max-width: 600px) {
  .title-main { font-size: 2.2rem; }
  .project-card { 
    width: 100% !important; 
    margin: 10px 0 !important; 
  }
  .project-image-container {
    height: 180px; /* Un poco más pequeña en móviles para ahorrar espacio */
  }
}
</style>